import {
  isInvalid, getFormValues,
} from 'redux-form';

export const aboutFormValuesSelector = (state) => getFormValues('about')(state);
export const aboutFormInvalidSelector = (state) => isInvalid('about')(state);
